import React, { useState } from 'react';
import { useResponsiveStyles } from './useResponsiveStyles';


function AccordionComponent({ items, template = "default", styles = {} }) {
    const [openIndexes, setOpenIndexes] = useState([]);

    const handleToggle = (index) => {
        setOpenIndexes((prev) => 
            prev.includes(index) 
                ? prev.filter((i) => i !== index) 
                : [...prev, index]
        );
    };


    const containerClassName = `${template.toLowerCase()}-accordion`;
    const appliedStyles = useResponsiveStyles(styles);

    const headerStyles = appliedStyles?.header || {};
    const bodyStyles = appliedStyles?.body || {};
    const buttonStyles = appliedStyles?.button || {};
    const containerStyles = appliedStyles?.container || {};
    
    return (
        <div className={`accordion ${containerClassName}`} id="accordionExample" style={containerStyles}>
            {items && items.length > 0
                ? items.map((item, index) => (
                    <div className="accordion-item" key={index}>
                        <h2 className="accordion-header" id={`heading${index}`} >
                            <button 
                                className="accordion-button" 
                                type="button" 
                                style={headerStyles}
                                onClick={() => handleToggle(index)} 
                                aria-expanded={openIndexes.includes(index)} 
                                aria-controls={`collapse${index}`}>
                                {item.title}
                            </button>
                        </h2>
                        <div 
                            id={`collapse${index}`} 
                            className={`accordion-collapse collapse ${openIndexes.includes(index) ? 'show' : ''}`} 
                            aria-labelledby={`heading${index}`} 
                            data-bs-parent="#accordionExample">
                            <div className="accordion-body" style={bodyStyles}>
                                {item.content}
                            </div>
                        </div>
                    </div>
                ))
                : <div className="accordion-item">
                    <h2 className="accordion-header" id="heading0" >
                        <button 
                            className="accordion-button" 
                            type="button" 
                            style={headerStyles}
                            onClick={() => handleToggle(0)} 
                            aria-expanded={openIndexes.includes(0)} 
                            aria-controls="collapse0">
                            Default Item
                        </button>
                    </h2>
                    <div 
                        id="collapse0" 
                        className={`accordion-collapse collapse ${openIndexes.includes(0) ? 'show' : ''}`} 
                        aria-labelledby="heading0" 
                        data-bs-parent="#accordionExample">
                        <div className="accordion-body" style={bodyStyles}>
                            Default Content
                        </div>
                    </div>
                </div>}
        </div>
    );
}

export default AccordionComponent;
